import { Component, OnInit, ElementRef, ViewChild, EventEmitter, AfterViewInit,Output,Input } from '@angular/core';
import { BdpService } from '../../../../areas/bdp/bdp.service';
import { environment } from '../../../../../environments/environment';
import { SwHttpClientService } from '../../../serves/sw-http-client.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
declare var $: any;
@Component({
  selector: 'sw-dynamic-form-link-form',
  templateUrl: './sw-dynamic-form-link-form.component.html',
  styleUrls: ['./sw-dynamic-form-link-form.component.css']
})
export class SwDynamicFormLinkFormComponent implements OnInit, AfterViewInit {
  headerLoGo:string = "关联表单"
  formId = "";
  formInformation = {};
  queryElement = [];
  listElement = [];
  queryInformation = {};
  information = [];
  data = {};
  pageBase: any = { current: 1, size: 10 }
  SelectData: any = [];
  checkedData: any;
  prefix: string = environment.seekerWebAPI;
  environmentWebAPI: string = '';
  environmentCkeditor: string = environment.staticFileUrl
  tableId;
  primaryKey; //主键字段channel_id
  SelectOpen = false; // 搜索下拉判断
  dictionaryDatas: any = [];//获取所有字典数据
  formRequestUrl: any = {}; //表单元素对应数据来源url对象
  keyWord: string = '' //流程关键字
  actFlagParam= {} // 流程审核状态属性为true 的表单元素对象
  flowItem: any = {} //根据formId,从发起流程数据匹配出发起流程中一条json对象， 获取submitUrl 、flowName 
  isLoading: boolean = false;
  isUseOrg:boolean = false; //判断表单属性是否有 isOrg=true的情况,如果有则isUseOrg=true,反之isUseOrg=false（execute的接口用到;新增、修改、删除和查询表单时用到）
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  @ViewChild('modal') modal: SwModalframeComponent; //模态框组件
   constructor(
     public element: ElementRef,
     private service: BdpService,
     private http: SwHttpClientService,
     private create:SwCreateModalComponentService,
     private systemId:SystemIdService,
     private jwt: SwJwtService,
   ) { }
 
 
   ngOnInit() {
     this.environmentWebAPI = this.param['environmentWebAPI']
     this.initFormInformation(this.param['tableId'], this.param['formId'])
   }
 
   ngAfterViewInit() {
   }
 
   

   initFormInformation(tableId, formId) {
    this.clearValue()
    this.formId = formId; // 获取到formId
    this.formInformation = { formId: this.formId };

    // 查询表单参数
    this.queryParamsPageList(this.formId).subscribe(response => {
      let params = [];
      params = (<any>response).data.records;
      params.forEach(val=>{
        if(val.controlType == 'input'){
           val.paramCode = 'examine_id'
        }
        
      })
    
      this.formInformation['params'] = params;
      if (params.length) {
        let keyparam = params.filter(item => item.type == 'key');
        keyparam.forEach(val=>{
           //获取主数据表 对应的绑定主键列表
           if(val.controlType == 'text'){
             this.tableId = val['tableId']
             this.primaryKey = val['paramCode']
           }
        })
      }
       //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
       this.getTableFk(this.tableId);
      //数据来源url和paramCode组成的对象
      this.formInformation['params'].forEach(val=> {
        this.formRequestUrl[val.paramCode] = val.requestUrl
          //判断表单元素是否为工作流表单   获取流程审核状态属性 isActFlag = true
          if(val.isActFlag == true) {
             this.actFlagParam = val;
             this.locationKeyWords()
          }
      })
      //初始化查询元素
      this.initQueryElement(this.formInformation);
      //初始化查询元素的数据收集对象
      this.initQueryInformation(this.formInformation);
      //初始化列表元素
      this.initListElement(this.formInformation);
      //获取字典数据
      //从浏览器缓存获取字典数据
      let dic = JSON.parse(this.jwt.getToken('dictionary'))
      this.dictionaryDatas = [...dic]
      //初始化下拉框、单选框、多选框的数据类型
      this.initRequestUrl(this.formInformation);
      setTimeout(()=>{
        // 查询业务数据列表
        this.getPageList();
      },200)
    })
   }

     //根据主表的tabeId, 获取该主数据表所有的外键  paramCode 和 coulmId  再根据coulmId 获取对应现有表单元素elements的paramCode
  getTableFk(keyTableId){
    let param = { ids:[ keyTableId],systemId:this.systemId.getSystemId()};
    //根据主表tableId查询对应的 主键字段列表
    this.service.getFormDesignService().queryColumnsByTableId(param).subscribe(res => {
      if(res['code']==200){
        let columns = res['data'];
         //判断主表是否为组织权限
         if(columns.length > 0){
          //判断该表单的是否包含属性 isOrg = true的元素，若有 this.isUseOrg = true 否则 this.isUseOrg=false
          let orgs = columns.filter(item=>item.isOrg == true)
          if(orgs.length == 0){
            this.isUseOrg=false
          }else {
            this.isUseOrg = true
          }
        }
      }
      

    });
  }
     //加载数据,根据formId获取keyWord
     locationKeyWords() {
      let param = { entity: {}, param: { pageNum: 1, pageSize: 0 } }
      this.getInitiationProcessList(param).subscribe(data => {
        if (data["code"] == 200) {
          //获取到所有的类型
          data["data"].forEach(el => {
            if(el.formId == this.formId) {
              this.keyWord = el.keyWord;
              this.flowItem = el;
            }
          });
        }
      })
    }
  
    getInitiationProcessList(param:any) {
      const url = environment.activitiWebAPI + "swActivitiModel/queryListByType"; 
      return this.http.Post(url, param);
    }

     /**
 * 查询列表
 * @param {any} formId 
 * @param {any} pager 
 * @param {any} param //查询条件
 * @memberof TestListComponent
 */
  getPageList() {
    this.isLoading = true;
    const url = this.environmentWebAPI+"dynamic/"+ 'execute?action=1&formId=' + this.formId + `&isUseAlias=true&pageNum=${this.pageBase.current}&pageSize=${this.pageBase.size}&isUseOrg=${this.isUseOrg}`;
    // 过滤已删除的数据
    let param = {}

    //若为流程审核表单  找出流程审核表单元素  0:未提交, 1:审核中, 2:已通过, 3:已驳回, 4:退回重审
    if(this.actFlagParam['isActFlag'] == true) {
      param[this.actFlagParam['tableId'] + '.' + this.actFlagParam['paramCode']] = ['like', 2 , '']
    }
    let queryParams = this.queryElement;
    if (queryParams.length > 0) {
      queryParams.map(item => {
        let value = this.queryInformation[item.paramCode];
        if (value != null && value != '') {
          if(item.controlType=='datePicker') {
            let time = this.queryInformation[item.paramCode];
            let beginTime = time.split("#")[0] + " 00:00:00";
            let endTime = time.split("#")[1] + " 23:59:59";
            param[item.tableId + '.' + item.paramCode] = ['between', beginTime + "#" + endTime, ''];
          }else {
            param[item.tableId + '.' + item.paramCode] = ['like', this.queryInformation[item.paramCode], '']
          }
        }
      })
    }
    // 查询业务数据
    this.http.Post(url, param).subscribe(res => {
      this.isLoading = false;
      this.information = (<any>res).data.data.list;
      let page = (<any>res).data.data;
      this.pageBase['current'] = page.pageNum;
      this.pageBase['pages'] = Math.ceil(page.total * 1.0 / page.pageSize);
      this.pageBase['size'] = page.pageSize;
      this.pageBase['total'] = page.total;
    })
  }
  //字典中value对应的text值
  initDictionaryText(paramCode,datas) {
    //如果数据来源url不为空
    if(this.formRequestUrl[paramCode]){
      let requestUrl = this.formRequestUrl[paramCode]
      let param1 = requestUrl.split("/")[1];
      //决定那条数据
      let param2 = requestUrl.split("/")[2];
      //判断元素类型
      let type = this.formInformation['params'].filter(item=> item.paramCode == paramCode)[0]['controlType']
      //对数据来源的数据进行过滤
      //param为1 数据来源为字典
      if(param1 == 1) {
        let data = datas +"";//设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
        //获取页面字典值 
        let dataArray = []
        if(data) {
          dataArray = data.split(",");
        }
         //获取页面字典 text值
         let dataString = '';
         let requestUrlData = this.dictionaryDatas.filter(val=> {
          return val.parentId == param2;
         })
         requestUrlData.forEach(val=>{
             dataArray.forEach(ele=> {
                //判断是否为is_xx true 或者false
                if (ele == 'true') {
                  ele = '1'
                } else if (ele == 'false') {
                  ele = '0'
                }
               if(val.dictionaryValue == ele){
                 dataString=dataString + "<span class=\"state-success\">"+val.dictionaryName+"</span> "
               }
             })
         })
         return dataString
      }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')){
        //当为关联表单中的字典值时
        let data = datas +"";//设置为字符串 将值为 true 或false 转化为字符串 便于后面分割为数组
        //获取页面字典值 
        let dataArray = []
        if(data) {
          dataArray = data.split(",");
        }
        let dataString = '';
        dataArray.forEach(ele=> {
          //判断是否为is_xx true 或者false
          if (ele == 'true') {
            ele = '1'
          } else if (ele == 'false') {
            ele = '0'
          }
          let dictionaryName = this.dictionaryDatas.filter(item=>item.dictionaryValue == ele)[0]['dictionaryName']
          dataString=dataString + "<span class=\"state-success\">"+dictionaryName+"</span> "
       })
       
        return dataString
      }else {
        return datas
      }
    }else if(this.actFlagParam['paramCode'] == paramCode){
      //返回原来值
      return  this.auditState(datas)
    }else {
      return datas
    }

  }

  //页面匹配审核状态
  auditState(state) {
    let  dataString = '';
    switch (state){
      case 0:  dataString = '<span style="cursor:pointer"  class="state-error">未提交</span>'; break;
      case 1:  dataString = '<span style="cursor:pointer"  class="state-info">审核中</span>'; break;
      case 2:  dataString = '<span style="cursor:pointer"  class="state-success">已通过</span>'; break;
      case 3:  dataString = '<span style="cursor:pointer"  class="state-waring">已驳回</span>'; break;
      case 4:  dataString = '<span style="cursor:pointer"  class="state-error">退回重审</span>';  break; 
  }
  return dataString
  }


   //点击单选框触发事件
   radioOnChange(e,val,element) {
    if(e.target.checked){
      this.queryInformation[element.paramCode] = val.id+'';
    }
  }
  //判断单选框是否为 是和否两项   为两项返回true用radio  大于两项用下拉框展示
  judgeRadio(data) {
    if(data.requestData){
    if(data.requestData.length != 2) {
      return false
    }else {
      let num = 0;
      data.requestData.forEach(val=>{
        if(val.text == '是'){
          num = 1;
        }
      })
      if(num ==1){
        return true
      }else {
        return false
      }
    }
    }
  }
  clickSelect(){
    this.pageBase.current = 1;
    this.getPageList();
  }
  reset() {
    $(".icheck-turquoise input[type='radio']").prop("checked",false)
    this.queryInformation = {};
    this.getPageList();
  }

  //分页
  ClickPageQuery(event) {
    this.pageBase = event;
    this.getPageList();
  }


  //初始化查询元素
  initQueryElement(formInformation) {
    let params = formInformation.params;
    params.forEach((val) => {
      if (val.isQueryParam == 1) {
        this.queryElement.push(val);
      }
    })
  }
  
   //初始化单选框、下拉框、多选框的数据
   initRequestUrl(formInformation) {
    //用于存储接受的数据
    //发送请求的参数
    let Params = { "param": { pageSize: 0 } };
    let elements = formInformation.params;
    let that = this;
    elements.forEach((value) => {
      let arr = [];
      if (value.requestUrl) {
        //决定数据来源
        let param1 = value.requestUrl.split("/")[1];
        //决定那条数据
        let param2 = value.requestUrl.split("/")[2];
        let type = value['controlType']; //获取元素类型
        value.requestData = "";
        //param1为1时  数据来源为字典
        if(param1 == 1){
            //对数据来源的数据进行过滤
            let requestUrl = this.dictionaryDatas.filter(val => {
              return val.parentId == param2;
            });
            requestUrl = requestUrl.map((val, index) => {
              return {
                id:val.dictionaryValue,
                text: val.dictionaryName,
                status: false
              }
            });
            //确定需要的数据
            value.requestData = requestUrl;
        }else if(param1 == 0 && (type =='radio' || type =='checkbox' || type =='select' || type =='selectCheckbox')){
          //关联表单
          //数据来源为绑定的表单
          let formId = param2
          //根据formId获取关联的表单元素
          this.queryParamsPageList(formId).subscribe(response => {
            let pairParam2='';//关联表单对应的表单字段元素 对应的字典 id
            let params = [];
            params = (<any>response).data.records;
            pairParam2 = params.filter(item=>item['paramCode'] == value['paramCode'])[0]['requestUrl'].split("/")[2];
            //对数据来源的数据进行过滤
            let requestUrl = this.dictionaryDatas.filter(val => {
              return val.parentId == pairParam2;
            });
            requestUrl = requestUrl.map((val, index) => {
              //将id修改为val.id
              return {
                id: val.dictionaryValue,
                text: val.dictionaryName,
                status: false
              }
            });
            //确定需要的数据
            value.requestData = requestUrl;
          })

        }
      }
    })
  }
  //初始化查询数据收集
  initQueryInformation(formInformation) {
    let params = formInformation.params;
    params.forEach((val) => {
      if (val.isQueryParam == 1) {
        this.queryInformation[val.paramCode] = ""
      }
    }, this)
  }
  //初始化列表元素
  initListElement(formInformation) {
    let params = formInformation.params;
    params.forEach(val => {
      if (val.isListParam == 1) {
        this.listElement.push(val);
      }
    })
  }

  initData(val) {
    if (val.requestUrl) {
      let value = {};
      val.requestData.forEach(v => {
        value[v.id] = v.text;
      })
      this.data[val.paramCode] = value;
    }
  }



  // 选择数据
  OutSelectData(event) {
    if (event.length > 0) {
      this.checkedData = event[eval.length - 1];
      this.SelectData = event;
    } else {
      this.SelectData = [];
      this.checkedData = null;
    }
  }

  //点击取消
  clickCancel() {
    let val = {code:false,data:[]}
    this.modal.toggle()
    this.callback.emit(val)
  }

  //点击确定
  confirmData() {
    let outDatas = [this.checkedData,{tableId:this.tableId}]
    let val = {code:true,data:outDatas}
    this.modal.toggle()
    this.callback.emit(val)
  }

  //清空数据
  clearValue() {
    this.formId = "";
    this.formInformation = {};
    this.queryElement = [];
    this.listElement = [];
    this.queryInformation = {};
    this.information = [];
    this.data = {};
    this.pageBase = { current: 1, size: 10 }
    this.SelectData = [];
    this.checkedData = {};
    this.tableId="";
    this.primaryKey=""; //主键字段channel_id
    this.SelectOpen = false; // 搜索下拉判断
    this.dictionaryDatas = [];//获取所有字典数据
    this.formRequestUrl = {}; //表单元素对应数据来源url对象
   }

  /**
 * 根据formId查询参数
 * @param param
 * @returns {Observable<any>}
 */
  queryParamsPageList(formId) {
    let param = {
      entity: { formId: formId },
      param: { pageSize: 0, orderBy: "seq" }
    }
    const url = this.prefix + 'form/queryParamsPageList';
    return this.http.Post(url, { ...param });
  }
 


}



